import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-view" }

import { emit } from '@nextcloud/event-bus'
import { computed, onMounted, watch, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import CallFailedDialog from '../components/CallView/CallFailedDialog.vue'
import CallView from '../components/CallView/CallView.vue'
import ChatView from '../components/ChatView.vue'
import LobbyScreen from '../components/LobbyScreen.vue'
import PollViewer from '../components/PollViewer/PollViewer.vue'
import TopBar from '../components/TopBar/TopBar.vue'
import { useIsInCall } from '../composables/useIsInCall.js'
import { useActorStore } from '../stores/actor.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainView',
  props: {
    token: {}
  },
  setup(__props: any) {

const props = __props

const store = useStore()
const isInCall = useIsInCall()
const router = useRouter()
const route = useRoute()
const actorStore = useActorStore()

const isInLobby = computed(() => store.getters.isInLobby)
const connectionFailed = computed(() => store.getters.connectionFailed(props.token))

watch(isInLobby, (isInLobby) => {
	// User is now blocked by the lobby
	if (isInLobby && isInCall.value) {
		store.dispatch('leaveCall', {
			token: props.token,
			participantIdentifier: actorStore.participantIdentifier,
		})
	}
})

onMounted(() => {
	watchEffect(() => {
		if (route.hash === '#direct-call') {
			emit('talk:media-settings:show', '')
			router.replace({ hash: '' })
		} else if (route.hash === '#settings') {
			emit('show-conversation-settings', { token: props.token })
			router.replace({ hash: '' })
		}
	})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isInLobby.value)
      ? (_openBlock(), _createBlock(LobbyScreen, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(TopBar, { "is-in-call": _unref(isInCall) }, null, 8, ["is-in-call"]),
          (_unref(isInCall))
            ? (_openBlock(), _createBlock(CallView, {
                key: 0,
                token: __props.token
              }, null, 8, ["token"]))
            : (_openBlock(), _createBlock(ChatView, { key: 1 })),
          _createVNode(PollViewer),
          (connectionFailed.value)
            ? (_openBlock(), _createBlock(CallFailedDialog, {
                key: 2,
                token: __props.token
              }, null, 8, ["token"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})